import jwt from 'jsonwebtoken';
import api from '@/api/index';
import router, {ROUTE_AFTER_LOGIN, ROUTE_AFTER_LOGOUT} from '../../../router';
import Vue from 'vue';

const state = {
  token: localStorage.getItem('token'),
};

const getters = {
  getToken: state => {
    return state.token;
  },
  getUserFromToken: state => {
    let decodedToken = jwt.decode(state.token);
    return decodedToken.userData;
  },
  getSettingsFromToken: state => {
    let decodedToken = jwt.decode(state.token);
    return decodedToken.userData.settings;
  },
};

const actions = {
  login(context, payload) {
    api.session.login(payload)
      .then(response => {
        const token = response.headers['new_token'];
        context.commit('loginSuccessHandler', token);
      })
      .catch(error => {
        console.log(error);
        context.commit('failureHandler', error.response.data.error);
      })
  },
  loginThroughToken(context, payload) {
    context.commit('loginTokenHandler', payload.token);
  },
  logout(context) {
    context.commit('logoutHandler');
  },
  updateLoginCredentials(context, payload) {
    return api.clients.updateLogin(payload)
      .then(response => {
        const token = response.headers['new_token'];
        context.commit('changedLoginCredentialsSuccessHandler', token);
        return true;
      })
      .catch(error => {
        console.log(error)
        context.commit('failureHandler', error.response.data.error);
        return false;
      })
  },
  updateSettings(context, payload) {
    return api.clients.updateSettings(payload)
      .then(response => {
        const token = response.headers['new_token'];
        context.commit('changedUserSettingsSuccessHandler', token);
        return true;
      })
      .catch(error => {
        console.log(error)
        context.commit('failureHandler', error.response.data.error);
        return false;
      })
  },
  changePlan(context, payload) {
    return api.clients.requestChangePlan(payload)
      .then(response => {
        const token = response.headers['new_token'];
        context.commit('requestChangePlanSuccessHandler', token);
        return true;
      })
      .catch(error => {
        console.log(error)
        context.commit('failureHandler', error.response.data.error);
        return false;
      })
  },
  addUserToClient(context, payload) {
    return api.clients.addUserToAccount(payload)
      .then(response => {
        context.commit('userAddedToAccountHandler');
        return true;
      })
      .catch(error => {
        console.log(error)
        context.commit('failureHandler', error.response.data.error);
        return false;
      })
  },
  updateUserStatus(context, payload){
    return api.clients.updateUserStatus(payload)
      .then(response => {
        const token = response.headers['new_token'];
        context.commit('userChangedStatus', {token, payload});
        return true;
      })
      .catch(error => {
        console.log(error)
        context.commit('failureHandler', error.response.data.error);
        return false;
      })
  },
  updateUserNotification(context, payload){
    return api.clients.updateNotification(payload)
      .then(response => {
        const token = response.headers['new_token'];
        context.commit('userChangedNotification', {token, payload});
        return true;
      })
      .catch(error => {
        console.log(error)
        context.commit('failureHandler', error.response.data.error);
        return false;
      })
  }
};

const mutations = {
  loginSuccessHandler(state, token) {
    localStorage.setItem('token', token);
    state.token = token;
    // Vue.$ga.event('Session', 'login');
    Vue.$gtag.event('login', {
      event_category: 'Session'
    });
    Vue.notify({
      group: 'actions',
      type: 'success',
      text: 'Welcome back!'
    });
    router.push(ROUTE_AFTER_LOGIN);
  },
  loginTokenHandler(state, token) {
    localStorage.setItem('token', token);
    state.token = token;
    Vue.$gtag.event('login', {
      event_category: 'Session',
      event_label: 'Token login'
    });
    Vue.notify({
      group: 'actions',
      type: 'success',
      text: 'Welcome back!'
    });
    router.push(ROUTE_AFTER_LOGIN);
  },
  failureHandler(state, message) {
    Vue.notify({
      group: 'actions',
      type: 'error',
      text: message
    });
  },
  logoutHandler() {
    delete localStorage.token;
    Vue.$gtag.event('Session', 'logout');
    router.push(ROUTE_AFTER_LOGOUT);
  },
  changedLoginCredentialsSuccessHandler(state, token){
    Vue.notify({
      group: 'actions',
      type: 'success',
      text: 'Login credentials successfully updated'
    });
    localStorage.setItem('token', token);
    state.token = token;
    // Vue.$ga.event('Clients', 'changed login credentials');
    Vue.$gtag.event('changed login credentials', {
      event_category: 'Clients'
    });
  },
  changedUserSettingsSuccessHandler(state, token){
    Vue.notify({
      group: 'actions',
      type: 'success',
      text: 'Settings successfully updated'
    });
    localStorage.setItem('token', token);
    state.token = token;
    // Vue.$ga.event('Clients', 'changed user settings');
    Vue.$gtag.event('changed user settings', {
      event_category: 'Clients'
    });
  },
  requestChangePlanSuccessHandler(state, token){
    Vue.notify({
      group: 'actions',
      type: 'success',
      text: 'Request to change plan successful'
    });
    localStorage.setItem('token', token);
    state.token = token;
    // Vue.$ga.event('Clients', 'requested upgrade');
    Vue.$gtag.event('requested upgrade', {
      event_category: 'Clients'
    });
  },
  userAddedToAccountHandler(state, token){
    Vue.notify({
      group: 'actions',
      type: 'success',
      text: 'User successfully added to your account'
    });
    // Vue.$ga.event('Clients', 'user added to account');
    Vue.$gtag.event('user added to account', {
      event_category: 'Clients'
    });
  },
  userChangedNotification(state, data){
    const {token, payload} = data;
    if (data.token) {
      state.token = token;
      localStorage.setItem('token', token);
    }
    Vue.notify({
      group: 'actions',
      type: 'success',
      text: `${payload.email} will ${payload.notification ? '':' not '} receive notifications`
    });
    // Vue.$ga.event('Clients', 'user changed notification');
    Vue.$gtag.event('user changed notification', {
      event_category: 'Clients'
    });
  },
  userChangedStatus(state, data){
    const {token, payload} = data;
    if (data.token) {
      state.token = token;
      localStorage.setItem('token', token);
    }
    Vue.notify({
      group: 'actions',
      type: 'success',
      text: `${payload.email} is now ${payload.status}`
    });
    // Vue.$ga.event('Clients', 'user changed notification');
    Vue.$gtag.event('user changed status', {
      event_category: 'Clients'
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js